import { Capacitor } from '@capacitor/core'
import * as Sentry from '@sentry/browser'
import React from 'react'
import { createRoot } from 'react-dom/client'
import '../processEnv'

const start = async () => {
  const [
    { default: getSentryConfig },
    { default: AppRoot },
    { resolveLocale },
    { default: AppEntry },
  ] = await Promise.all([
    import('system/getSentryConfig'),
    import('../shared/appRoot'),
    import('../shared/resolveLocale'),
    import('./AppEntry'),
  ])

  if (!Capacitor.isNativePlatform()) {
    Sentry.init(getSentryConfig('browser'))
  }

  const { locale } = await resolveLocale()
  const root = document.querySelector('#root')
  if (!root) throw new Error('Missing root element')

  createRoot(root).render(
    <AppRoot locale={locale}>
      <AppEntry />
    </AppRoot>,
  )
}

void start()
